module.exports = __webpack_public_path__ + "img/bot-blue.07c2cf55.svg";